module.exports = __webpack_public_path__ + "fonts/Golos-Text_Bold.2277f90.woff2";